import {Client} from "./client";
import {User} from "./user";;
import { Assignment } from "./Assignment";
import { AssignedAssessmentGroup } from "./AssignedAssessmentGroup";
import { AssignedAssessment } from "./AssignedAssessment";
import { AssignmentItem } from "./AssignmentItem";
import { AssignedLibraryAsset } from "./AssignedLibraryAsset";

// TODO: stephen look at moving this into the models
export class ManagedClient extends Client {
    // TODO: stephen move these into private getter/setters.
    public assignments:Assignment[];
    public firstName:string;
    public lastName:string;
    public displayName:string; // display name of the client used on the client side only for now.
    public email:string;
    private assignedUser:User;
    
    public constructor() {
        super();
        this.assignments = [];
    }

    public get user() {
        return this.assignedUser;
    }
    public set user(v:User) {
        this.assignedUser = v;
    }

    public getAssessmentGroups()  : AssignedAssessmentGroup[] {
        let groups:AssignedAssessmentGroup[] = [];
        this.assignments.forEach(a => {
            if ( a.Type == "AssessmentGroup") {
                groups.push(a as AssignedAssessmentGroup);
            }
        });
        return groups;
    }
    
    /**
     * Looks for the passed in assignment and removes it if it is found
     * in the current client.  If it is not found it's treated as a no-op.
     */
    public removeAssignment(assignment:Assignment) {
        let indexOf = this.assignments.indexOf(assignment);
        if (indexOf >= 0) {
            this.assignments.splice(indexOf, 1);
        }
    }

    public getAssignmentsCompleted() {
        return this.assignments.filter((a) => a.IsComplete).length;
    }
    public hasNoAssignments() {
        return this.assignments.length == 0;
    }
    public hasFinishedAllAssignments() {
        if (this.assignments.length) {
            return this.assignments.every(a => a.IsComplete);
        }
        return false;
    }
    public getNextAssignmentItemToComplete() : AssignmentItem {
        // find the first assignment that is not complete.

        let assignment = this.assignments.find((a) => !a.IsComplete);
        if (!assignment) {
            return null;
        }
        let item = assignment.getNextAssignmentItemToComplete();
        if (!item) {
            console.error("Assignment marked as incomplete but items are complete. Assignment:", assignment);
        }
        return item;
    }

    public getAssignment(id:number) {
        if (!this.assignments) {
            return null;
        }
        
        return this.assignments.find(a => a.Id == id);
    }

    public findAssignmentItem(id:number) {
        let assignment = null;
        this.assignments.some(a => {
            let item = a.Items.find(i => i.Id == id);
            if (item) {
                assignment = item;
                return true;
            }
            return false;
        });
        return assignment;
    }

    public hasStartedAssignments() {
        return this.assignments && this.assignments.length && this.assignments[0].IsComplete;
    }

    public getDisplayString() {
        let name = [];
        
        if (this.firstName || this.lastName) {
            if (this.firstName) {
                name.push(" ");
                name.push(this.firstName);
            }
            if (this.lastName) {
                name.push(" ");
                name.push(this.lastName);
            }
        }
        else {
            name.push("<NAME MISSING>");
        }
        return name.join("");
    }

    public findAssignmentForAssignmentItem(item:AssignmentItem) {
        return this.assignments.find((a) => a.hasItem(item));
    }

    public findAssignmentItemForAssessmentUid(uid:string) : AssignedAssessment {
        let assignment = this.assignments.find((a) => {
			if (a.Type == "Assessment" && a.Items.length) {
				let assignedAssessment = a.Items[0] as AssignedAssessment;
				if (assignedAssessment.Uid == uid) {
					return true;
				}
				return false;
			}
        });
        if (assignment) {
            return assignment.Items[0] as AssignedAssessment;
        }
        return null;
    }

    public findAssignmentItemForAssetId(assetId:number) : AssignedLibraryAsset {
        let assignment = this.assignments.find((a) => {
			if (a.Type == "LibraryAsset") {
				let assignedAsset = a.Items[0] as AssignedLibraryAsset;
				if (assignedAsset.AssetId == assetId) {
					return true;
				}
				return false;
			}
        });
        if (assignment) {
            return assignment.Items[0] as AssignedLibraryAsset;
        }
        return null;
    }

    public markAssignmentCompleted(item:AssignmentItem) {
        if (!(item && item.Id)) {
            throw new Error("Missing item or item id");
        }

        let assignment = this.findAssignmentForAssignmentItem(item);
        if (assignment) {
            assignment.markCompleted(item);
        } else {
            throw new Error("Failed to find assignment for item" + item.Id);
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/models/managed-client.ts